import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';
import { Visible } from '../visible';

export const StyledSectionTitle = styled(FlexBox)`
    margin: 80px 0 80px;

    ${media.sm`
        margin: 96px 0 32px;
    `}
`;

export const StyledChildrenWrapper = styled.div`
    padding: 30px 0;
`;

export const StyledVisible = styled(Visible)`
    width: 100%;
`;
